import React, { Component } from 'react'
import { Provider } from 'mobx-react'
import { Router } from 'routes'
import { RootStore } from 'store'

class App extends Component {
  render () {
    return (
      <Provider {...new RootStore()}>
        <Router />
      </Provider>
    )
  }
}

export default App
